import { showErrorAlert } from 'actions';
import Modal from 'components/Modal';
import useStartNewSession from 'hooks/agentSessions/useStartNewSession';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCustomerDomain } from 'selectors/auth';
import { useSelector } from 'store';
import { useHistory } from 'utils/urls';

type ComponentProps = {
  isModalOpen: boolean;
  toggleModalOpen: () => void;
  onCreated: () => void;
};

const CreateAgentSessionModal: React.FC<ComponentProps> = ({
  isModalOpen,
  toggleModalOpen,
  onCreated,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { investigationId } = useParams<{ investigationId: string }>();

  const customer = useSelector(getCustomerDomain);

  const { mutateAsync: startNewSession, isLoading } = useStartNewSession();
  const [objective, setObjective] = useState('');

  const reset = (): void => {
    setObjective('');
  };

  const handleClose = (): void => {
    reset();
    toggleModalOpen();
  };

  const handleSubmit = async (): Promise<void> => {
    const trimmed = objective.trim();
    if (!trimmed) {
      dispatch(showErrorAlert('Name is required'));
      return;
    }
    const session = await startNewSession({
      urlParams: {
        investigationId,
      },
      data: {
        agent_objective: trimmed,
      },
    });
    reset();
    onCreated();
    if (investigationId && session?.uuid) {
      history.pushLookup({
        routeName: 'agent-chat',
        routeParams: { investigationId, agentId: session?.uuid },
        customerDomain: customer,
      });
    }
    toggleModalOpen();
  };

  const body = (
    <div className="flex flex-col gap-4 mt-10 mb-4 h-full text-body">
      <label className="flex flex-col gap-1" htmlFor="investigation-create-objective">
        <span>Agent Objective</span>
        <textarea
          id="investigation-create-objective"
          rows={3}
          className="form-input w-full text-litlingo-gray-6 text-body"
          value={objective}
          onChange={(e): void => setObjective(e.target.value)}
        />
      </label>
    </div>
  );

  return (
    <>
      {isModalOpen && (
        <Modal
          title="New session"
          body={body}
          toggleShowModal={handleClose}
          style={{ width: '37.5rem' }}
          okButton
          okButtonText="Create"
          okButtonDisabled={!objective.trim() || isLoading}
          okButtonOnClick={(): void => {
            handleSubmit().catch(() => undefined);
          }}
          cancelButton
          cancelButtonOnclick={handleClose}
          xButton
          loading={isLoading}
        />
      )}
    </>
  );
};

export default CreateAgentSessionModal;
